module.exports = __webpack_public_path__ + "img/ben.044e57a4.png";